export const PRESCRIPTION_CREATE_REQUEST = 'PRESCRIPTION_CREATE_REQUEST'
export const PRESCRIPTION_CREATE_SUCCESS = 'PRESCRIPTION_CREATE_SUCCESS'
export const PRESCRIPTION_CREATE_FAIL = 'RESCRIPTION_CREATE_FAIL'
export const PRESCRIPTION__CREATE_RESET = 'PRESCRIPTION__CREATE_RESET'



export const LIST_PRESCRIPTION_REQUEST = 'LIST_PRESCRIPTION_REQUEST'
export const LIST_PRESCRIPTION_SUCCESS = 'LIST_PRESCRIPTION_SUCCESS'
export const LIST_PRESCRIPTION_FAIL = 'LIST_PRESCRIPTION_FAIL'
export const LIST_PRESCRIPTION_RESET = 'LIST_PRESCRIPTION_RESET'

export const PRESCRIPTION_DELETE_REQUEST = 'PRESCRIPTION_DELETE_REQUEST'
export const PRESCRIPTION_DELETE_SUCCESS = 'PRESCRIPTION_DELETE_SUCCESS '
export const PRESCRIPTION_DELETE_FAIL = 'PRESCRIPTION_DELETE_FAIL'


export const LIST_PRESCRIPTION_ENUMS_REQUEST = 'LIST_PRESCRIPTION_ENUMS_REQUEST'
export const LIST_PRESCRIPTION_ENUMS_SUCCESS = 'LIST_PRESCRIPTION_ENUMS_SUCCESS'
export const LIST_PRESCRIPTION_ENUMS_FAIL = 'LIST_PRESCRIPTION_ENUMS_FAIL'
export const LIST_PRESCRIPTION_ENUMS_RESET = 'LIST_PRESCRIPTION_ENUMS_RESET'


export const UPDATE_PRESCRIPTION_REQUEST = 'UPDATE_PRESCRIPTION_REQUEST'
export const UPDATE_PRESCRIPTION_SUCCESS = 'UPDATE_PRESCRIPTION_SUCCESS'
export const UPDATE_PRESCRIPTION_FAIL = 'UPDATE_PRESCRIPTION_FAIL'
export const UPDATE_PRESCRIPTION_RESET = 'UPDATE_PRESCRIPTION_RESET'


export const PRESCRIPTION_DETAILS_REQUEST = 'PRESCRIPTION_DETAILS_REQUEST'
export const PRESCRIPTION_DETAILS_SUCCESS = 'PRESCRIPTION_DETAILS_SUCCESS'
export const PRESCRIPTION_DETAILS_FAIL = 'PRESCRIPTION_DETAILS_FAIL'

export const PRESCRIPTION_USER_DETAILS_REQUEST = 'PRESCRIPTION_USER_DETAILS_REQUEST'
export const PRESCRIPTION_USER_DETAILS_SUCCESS = 'PRESCRIPTION_USER_DETAILS_SUCCESS'
export const PRESCRIPTION_USER_DETAILS_FAIL = 'PRESCRIPTION_USER_DETAILS_FAIL'

export const LIST_PAID_ENUMS_REQUEST = 'LIST_PAID_ENUMS_REQUEST'
export const LIST_PAID_ENUMS_SUCCESS = 'LIST_PAID_ENUMS_SUCCESS'
export const LIST_PAID_ENUMS_FAIL = 'LIST_PAID_ENUMS_FAIL'
export const LIST_PAID_ENUMS_RESET = 'LIST_PAID_ENUMS_RESET'